
























































import Vue from 'vue'
import _ from 'lodash'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import moment from 'moment'
import { ShiftBreakPayload } from '@/types/payload'

interface ComponentData {
  showErrorSnackbar: boolean
  startBreak: string
  endBreak: string
  duration: string
  deductionCapacity: string
  comment: string
  startValidationRules: Array<Function>
  deductionCapacityRules: Array<Function>
}

export default Vue.extend({
  name: 'FreeShiftBreakDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    dialogData: {
      type: Object as () => ShiftBreak
    },

    title: String
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      showErrorSnackbar: false,
      startBreak: '00:00',
      endBreak: '00:00',
      duration: '00:00',
      deductionCapacity: '00:00',
      comment: '',
      startValidationRules: [required],
      // @ts-ignore
      deductionCapacityRules: [this.validateDeductionCapacity]
    }
  },

  computed: {
    durationTime (): string {
      if(this.startBreak && this.endBreak) {
        let startDuration: number = (moment(this.startBreak, 'HH:mm').hour() * 60) + moment(this.startBreak, 'HH:mm').minutes()
        let endDuration: number = (moment(this.endBreak, 'HH:mm').hour() * 60) + moment(this.endBreak, 'HH:mm').minutes()
        this.duration = (endDuration - startDuration).toString()

        this.deductionCapacity = moment.utc(parseInt(this.duration) *60 * 1000).format('HH:mm')
        return moment.utc(parseInt(this.duration) *60 * 1000).format('HH:mm')
      }
      this.deductionCapacity = ''
      return ''
    }
  },

  watch: {
    show (): void {
      this.resetForm()
    }
  },

  methods: {
    validateDeductionCapacity(v: string): boolean {
      if(v > this.durationTime) {
        return false
      } else {
        return true
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        const payload: ShiftBreakPayload = {
          startBreak: this.startBreak,
          endBreak: this.endBreak,
          duration: this.durationTime,
          deductionCapacity: this.deductionCapacity,
          comment: this.comment
        }

        if(this.dialogData) {
          this.$emit('editBreak', payload)
        } else {
          this.$emit('createNewBreak', payload)
        }
      }
    },

    resetForm () {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      if(this.dialogData) {
        this.startBreak = this.dialogData.startBreak
        this.endBreak = this.dialogData.endBreak
        this.duration = this.dialogData.duration
        this.deductionCapacity = this.dialogData.deductionCapacity
        this.comment = this.dialogData.comment
      } else {
        this.startBreak = '00:00'
        this.endBreak = '00:00'
        this.duration = '00:00'
        this.deductionCapacity = '00:00'
        this.comment = ''
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    }
  }
})
